import { Grid, Container } from '@mui/material';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import UserTable from './Components/RecentUserTable';
import UserListHeader from './Components/PageHeader';
import { useGetUsers } from './hook/useGetUserList';

function UserList() {
  const { data, refetch } = useGetUsers();
  return (
    <>
      <PageTitleWrapper>
        <UserListHeader refetch={refetch} />
      </PageTitleWrapper>
      <Container
        maxWidth="lg"
        className="mt-20"
        style={{
          marginTop: '20px'
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <UserTable data={data} refetch={refetch} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default UserList;
